import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=480e5e9a&"
import script from "./Apartment.vue?vue&type=script&lang=js&"
export * from "./Apartment.vue?vue&type=script&lang=js&"
import style0 from "./Apartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports